import React, {Component} from 'react'
import Banner from '../Component/Banner'
import BannerBottomInfo from '../Component/BannerBottomInfo'
import Feature from '../Component/Feature'
import Blog from './Blog/Blog'
import Introduce from '../Component/Introduce'
import Youtube from '../Component/Youtube'

export default class Home extends Component {
  componentDidMount () {
   window.scrollTo(0, 0)
  }
  componentWillUnmount() {
   window.scrollTo(0, 0)
  }
  render() {
    return(
      <div className="container-fluid">
       <div className="row">
        <Banner />
        <BannerBottomInfo />
        <Feature />
        <Introduce />
        <Youtube />
        <Blog />
       </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/Home.js